import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderWorkPlaceState {
  id: string;
  providerId: string;
  name: string;
  address: string;
  details?: string;
  props: {
    [key: string]: any;
  };
}

const initialState: ProviderWorkPlaceState = {
  id: '',
  providerId: '',
  name: '',
  address: '',
  details: '',
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const providerWorkPlaceSlice = createSlice({
  name: 'providerWorkPlace',
  initialState,
  reducers: {
    setProviderWorkPlace: (state, action: PayloadAction<Partial<ProviderWorkPlaceState>>) => {
      return { ...state, ...action.payload };
    },

    updateField: (state: ProviderWorkPlaceState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setProviderWorkPlace, updateField, updateProps } = providerWorkPlaceSlice.actions;

export default providerWorkPlaceSlice.reducer;
